import Vue from 'vue'
import { loadModules } from 'esri-loader'
import { mapState } from 'vuex'
import { gmapApi } from 'gmap-vue'
import { _ } from 'vue-underscore'
export default Vue.extend({
  data() {
    return {
      mapname: 'illimity',
      currentMap: null,
      basemapValue: 'topo-vector',
      loading: false,
      tokenregister: false,
      servergis: 'https://auragis.westeurope.cloudapp.azure.com',
      activelegend: false,
      legendtitle: '',
      typolegend: '',
      legendlevel: '',
      currentFilterLayer: null,
      map_type_popover: false,
      gsv_active: false,
      legendstops: [],
      sketchgraphview: null,
      rings_search: [
        []
      ],
      lockablemap: false,
      maplocked: false,
      assetColors: [
        [241, 140, 120],
        [184, 220, 148],
        [84, 130, 53],
        [179, 93, 132],
        [150, 208, 238],
        [86, 148, 194],
        [255, 217, 102],
        [210, 160, 0],
        [201, 201, 201],
        [234, 173, 122],
        [93, 199, 194],
        [241, 163, 243]
      ],
      usedTypos: [],
      activetypolegend: false,
      colorByProperty: null,
      mapLevelDate: ''
    }
  },
  computed: {
    ...mapState('user', {
      activeNav: (state) => state.activeNav
    }),
    ...mapState('location', {
      position: (state) => state.position,
      geolevelselected: (state) => state.geolevelselected,
      geolevels: (state) => state.geolevels
    }),
    ...mapState('valuations', {
      currentComparables: (state) => state.currentComparables,
      currentFilterValuations: (state) => state.currentFilter,
      selectedcomparables: (state) => state.selectedcomparables
    }),
    ...mapState('portfolio', {
      currentAssets: (state) => state.currentportfolio
    }),
    ...mapState('pois', {
      currentMapPois: (state) => state.MapPois
    }),
    ...mapState('maps', {
      selectedmap: (state) => state.selectedmap,
      selectedmapvisualization: (state) => state.selectedmapvisualization,
      maptoken: (state) => state.token,
      mapFilters: (state) => state.mapfilters
    }),
    google: gmapApi,
    isvaluations: function() {
      return this.activeNav === 'valuation'
    },
    isportfolio: function() {
      return this.activeNav === 'portfolio'
    },
    allowedColorCategories: {
      get() {
        var pfdata = this.currentAssets
        if (pfdata === null || pfdata.matchColumns === null) { return [] }
        var possibleCats = _.filter(pfdata.matchColumns, function(item) { return item.brainsId.indexOf('sset_Features') > 0 })
        return possibleCats
      }
    }
  },
  watch: {
    colorByProperty: function() {
      this.drawassets(false)
    },
    isvaluations: function() {
      this.showhidevaluations()
    },
    isportfolio: function() {
      this.showhideportfolio()
    },
    position: function() {
      const vm = this
      if (this.currentMap !== null) {
        this.centermapposition()
      } else {
        setTimeout(() => { vm.centermapposition() }, 2000)
      }
    },
    selectedmap: function() {
      this.applymapStyle()
    },
    mapFilters: function() {
      this.filterMapData()
    },
    geolevelselected: function() {
      this.setzoombylevel()
    },
    currentComparables: function() {
      this.drawcomparables()
    },
    currentAssets: function() {
      if (this.currentAssets.data.length === 0) {
        this.showhideportfolio()
      }
      const vm = this
      setTimeout(() => {
        vm.colorByProperty = vm.allowedColorCategories[0].brainsId
      }, 500)
    },
    currentMapPois: function() {
      this.drawpois()
    },
    activeNav: function() {
      this.currentAssets.data = []
      this.usedTypos = []
    }
  },
  created() {
    const vm = this
    vm.createmap()
    vm.$root.$on('HoverRankingData', (element) => {
      vm.removeHover = false
      vm.hoverRankingData(element)
    })
    vm.$root.$on('HoverRankingDataDelete', (element) => {
      vm.removeHover = true
      vm.removeRankingLevel()
    })
    vm.$root.$on('SelectRankingItem', (item) => {
      vm.selectRankingItem(item)
    })

    this.$root.$on('ShowComparableInMap', (comparable, isActive) => {
      this.setHoveredComparableStyle(comparable, isActive)
    })

    this.$root.$on('ShowAssetInMap', (asset, isHovered) => {
      this.setAssetComparableStyle(asset, isHovered)
    })
    this.$root.$on('RemoveHoveredAssetStyle', () => {
      this.removeAssetComparablesStyle()
    })
    this.$root.$on('mapResizeProperty', (propid) => {
      this.drawassets(false, propid)
    })

    this.$root.$on('TakeScreenshotExport', (radius) => {
      this.currentMapView.zoom = this.getZoomByRadiusExportVal(radius)
      this.currentMapView.center = [this.position.longitude, this.position.latitude]
      setTimeout(() => {
        this.currentMapView.takeScreenshot().then(async(screenshot) => {
          this.$store.dispatch('valuations/setImageMapExport', { value: screenshot })
        })
      }, 2000)
    })
  },
  methods: {
    removeAssetComparablesStyle() {
      const vm = this
      loadModules(['esri/symbols/SimpleMarkerSymbol']).then(([SimpleMarkerSymbol]) => {
        var hoverColor = [43, 163, 158]
        var hoveredComps = _.filter(vm.portassetGraphicView.graphics.items, function items(item) { return !!item.symbol.color && item.symbol.color.r === hoverColor[0] && item.symbol.color.g === hoverColor[1] && item.symbol.color.b === hoverColor[2] })
        for (var i = 0; i < hoveredComps.length; i++) {
          // var colorSym = [234, 196, 40, 0.8]

          hoveredComps[i].symbol = new SimpleMarkerSymbol({
            color: hoveredComps[i].attributes.default_colour,
            size: hoveredComps[i].attributes.default_px,
            angle: hoveredComps[i].symbol.angle,
            style: hoveredComps[i].symbol.style,
            outline: {
              color: [255, 255, 255],
              width: hoveredComps[i].symbol.outline.width
            }
          })
        }
      })
    },
    setAssetComparableStyle(graphic, isHovered) {
      var vm = this
      loadModules(['esri/symbols/SimpleMarkerSymbol']).then(([SimpleMarkerSymbol]) => {
        var targetComp = _.find(vm.portassetGraphicView.graphics.items, function items(item) { return item.attributes.id_portfolio === graphic.attributes.id_portfolio })
        if (targetComp) {
          targetComp.symbol = new SimpleMarkerSymbol({
            color: isHovered ? [43, 163, 158] : targetComp.attributes.default_colour,
            size: isHovered ? '15px' : targetComp.attributes.default_px,
            angle: targetComp.symbol.angle,
            style: targetComp.symbol.style,
            outline: {
              color: isHovered ? [43, 163, 158] : [255, 255, 255],
              width: targetComp.symbol.outline.width
            }
          })
        }
      })
    },
    drawpois() {
      const vm = this
      let graphicsArray = []
      loadModules([
        'esri/geometry/Point',
        'esri/Graphic',
        'esri/symbols/SimpleLineSymbol',
        'esri/symbols/SimpleMarkerSymbol',
        'esri/layers/FeatureLayer'
      ], { css: true }).then(([Point, Graphic, SimpleLineSymbol, SimpleMarkerSymbol, FeatureLayer]) => {
        if (vm.currentMap === null) return
        graphicsArray = vm.currentMapPois.map((feature) => {
          return new Graphic({
            geometry: new Point({
              longitude: feature.longitude,
              latitude: feature.latitude
            }),
            attributes: {
              poi: feature,
              name: feature.name
            }
          })
        })

        var poiRenderer = {
          type: 'simple', // autocasts as new SimpleRenderer()
          symbol: {
            type: 'simple-marker',
            color: [0, 0, 255, 0.8],
            size: '10px',
            angle: 180,
            style: 'circle',
            outline: {
              color: [255, 255, 255],
              width: '1px'
            }
          }
        }

        const layer = new FeatureLayer({
          title: 'poispoints',
          objectIdField: 'name', // inferred from fields array if not specified
          geometryType: 'point', // geometryType and spatialReference are inferred from the first feature
          spatialReference: { wkid: 4326 },
          source: graphicsArray,
          renderer: poiRenderer, // UniqueValueRenderer based on `type` attribute
          popupTemplate: {
            content: vm.popuptemplatepoi
          }
        })

        if (vm.poisGraphicView) {
          vm.currentMap.remove(vm.poisGraphicView)
        }
        vm.poisGraphicView = layer
        vm.currentMap.add(vm.poisGraphicView)
        vm.currentMapView.popup.close()
      })
    },
    popuptemplatepoi(item) {
      const vm = this
      const poi = vm.currentMapPois[item.graphic.attributes.name - 1]
      return '<div class="poistitle"><strong>' + poi.name + '</strong></div><div class="poistitle">' + vm.$t('distance') + ': ' + poi.distance + ' m</div>'
    },
    drawassets: function(changeZoom, resizeId) {
      const vm = this
      let graphicsArray = []
      loadModules([
        'esri/geometry/Point',
        'esri/Graphic',
        'esri/symbols/SimpleLineSymbol',
        'esri/symbols/SimpleMarkerSymbol'
      ], { css: true }).then(([Point, Graphic, SimpleLineSymbol, SimpleMarkerSymbol]) => {
        if (vm.currentMap === null) return
        // debugger
        if (changeZoom) { vm.currentMapView.zoom = 6 }

        // Localizados
        var assets = []
        vm.usedTypos = []
        if (!!vm.currentAssets && vm.currentAssets.data !== undefined) {
          assets = vm.currentAssets.data.filter(item => { return item.BrainsLatitude !== null && item.BrainsLongitude !== null })
          if (assets.length === 0) { return }

          var resizeAssets = false
          var keyId = resizeId || ''
          if (keyId === '' && !!vm.currentAssets.stratsConfig) {
            if (!!vm.currentAssets.stratsConfig.areaoptions && vm.currentAssets.stratsConfig.areaoptions.length > 0) {
              keyId = vm.currentAssets.stratsConfig.areaoptions[0].id
            } else if (!!vm.currentAssets.stratsConfig.valueoptions && vm.currentAssets.stratsConfig.valueoptions.length > 0) {
              keyId = vm.currentAssets.stratsConfig.valueoptions[0].id
            }
          }
          if (keyId !== '') {
            resizeAssets = true
            // y1 - px minimos del punto en mapa
            // y2 - px máximos
            var y1 = 8
            var y2 = 20
            var x1 = _.min(assets, function(item) { return item[keyId] })[keyId]
            var x2 = _.max(assets, function(item) { return item[keyId] })[keyId]
          }

          var groupAssets = false
          var isBucket = false
          var groups = []
          if (vm.currentAssets.matchColumns && !!vm.currentAssets.matchColumns.some(s => s.brainsId.indexOf('sset_Features') > 0)) {
            groupAssets = true
            var obj = vm.currentAssets.matchColumns.find(f => f.brainsId.indexOf('sset_Features') > 0)
            if (obj.brainsSection === 'VALUES' || obj.brainsSection === 'DATES' || obj.brainsSection === 'TIMING' || obj.brainsSection === 'SURFACE') {
              isBucket = true
              var bucketMin = _.min(assets, function(item) { return item[vm.colorByProperty] })[vm.colorByProperty] ?? 0
              var bucketMax = _.max(assets, function(item) { return item[vm.colorByProperty] })[vm.colorByProperty]
              for (var i = bucketMin; i <= bucketMax; i += (bucketMax - bucketMin) / 5) {
                groups.push(i)
              }

              for (var j = 0; j < groups.length - 1; j++) {
                vm.usedTypos.push({
                  typo: vm.$formatNumber(groups[j], 0) + ' - ' + vm.$formatNumber(groups[j + 1], 0),
                  color: j < vm.assetColors.length ? vm.assetColors[j] : [234, 196, 40, 0.8]
                })
              }
            } else {
              var typoGroup = _.groupBy(assets, vm.colorByProperty)
              groups = Object.keys(typoGroup)
              groups = _.sortBy(groups, function(item) { return typoGroup[item].length }).reverse()

              for (var k = 0; k < groups.length; k++) {
                vm.usedTypos.push({
                  typo: groups[k],
                  color: k < vm.assetColors.length ? vm.assetColors[k] : [234, 196, 40, 0.8]
                })
              }
            }
          }

          graphicsArray = assets.map((feature) => {
            var intr = 10
            if (resizeAssets) {
              var x = feature[keyId]
              intr = y1 + ((y2 - y1) / (x2 - x1)) * (x - x1)
            }

            var colorGroup = [234, 196, 40, 0.8]
            if (groupAssets) {
              if (isBucket) {
                for (var i = 0; i < groups.length; i++) {
                  if (feature[vm.colorByProperty] >= groups[i] && feature[vm.colorByProperty] <= groups[i + 1]) {
                    colorGroup = i < vm.assetColors.length ? vm.assetColors[i] : [234, 196, 40, 0.8]
                    break
                  }
                }
              } else {
                var indexGroup = groups.indexOf(feature[vm.colorByProperty])
                colorGroup = indexGroup < vm.assetColors.length ? vm.assetColors[indexGroup] : [234, 196, 40, 0.8]
              }
            }

            var symbol = new SimpleMarkerSymbol({
              color: colorGroup,
              size: Math.round(intr) + 'px',
              angle: 180,
              style: 'circle',
              outline: new SimpleLineSymbol({
                color: [255, 255, 255],
                width: '1px'
              })
            })
            debugger
            return new Graphic({
              geometry: new Point({
                longitude: feature.BrainsLongitude,
                latitude: feature.BrainsLatitude
              }),
              symbol: symbol,
              attributes: {
                id_portfolio: feature.id,
                default_px: Math.round(intr) + 'px',
                default_colour: colorGroup
              }
            })
          })
        }
        /*
        if (vm.currentAssets.country) {
          debugger
          var latLng = this.getCountryLatLng(vm.currentAssets.country)
          this.longitude = latLng[1]
          this.latitude = latLng[0]
        }
        */
        vm.portassetGraphicView.visible = true
        vm.portassetGraphicView.graphics = []
        vm.portassetGraphicView.graphics.addMany(graphicsArray)
      })
    },
    getZoomByRadiusExportVal(radius) {
      if (radius > 0 && radius <= 600) {
        return 16
      } else if (radius > 600 && radius <= 900) {
        return 15
      } else if (radius > 900 && radius <= 1500) {
        return 14
      } else if (radius > 1500 && radius <= 3200) {
        return 13
      } else if (radius > 3200 && radius <= 5900) {
        return 12
      } else if (radius > 5900 && radius <= 10000) {
        return 11
      } else {
        return 16
      }
    },
    setHoveredComparableStyle(graphic, isHovered) {
      const vm = this
      loadModules(['esri/symbols/SimpleMarkerSymbol']).then(([SimpleMarkerSymbol]) => {
        var targetComp = _.find(vm.assetGraphicView.graphics.items, function items(item) { return item.attributes.iD_comparable === graphic.attributes.iD_comparable })
        if (targetComp) {
          var colorSym = []
          var px = '10px'
          if (isHovered) {
            colorSym = [43, 163, 158]
            px = '15px'
          } else if (targetComp.attributes.pub && targetComp.attributes.active) {
            colorSym = [216, 175, 70, 1]
          } else if (targetComp.attributes.pub) {
            colorSym = [232, 210, 128, 1]
          } else if (targetComp.attributes.active) {
            colorSym = [194, 194, 194, 1]
          } else {
            colorSym = [240, 240, 240, 1]
          }

          targetComp.symbol = new SimpleMarkerSymbol({
            color: colorSym,
            size: px,
            angle: targetComp.symbol.angle,
            style: targetComp.symbol.style,
            outline: {
              color: isHovered ? [43, 163, 158] : [255, 255, 255],
              width: targetComp.symbol.outline.width
            }
          })
        }
      })
    },
    removeHoveredComparablesStyle() {
      const vm = this
      loadModules(['esri/symbols/SimpleMarkerSymbol']).then(([SimpleMarkerSymbol]) => {
        var hoverColor = [43, 163, 158]
        var hoveredComps = _.filter(vm.assetGraphicView.graphics.items, function items(item) { return item.symbol.color.r === hoverColor[0] && item.symbol.color.g === hoverColor[1] && item.symbol.color.b === hoverColor[2] })
        for (var i = 0; i < hoveredComps.length; i++) {
          var colorSym = []
          var px = '10px'
          if (hoveredComps[i].attributes.pub && hoveredComps[i].attributes.active) {
            colorSym = [216, 175, 70, 1]
          } else if (hoveredComps[i].attributes.pub) {
            colorSym = [232, 210, 128, 1]
          } else if (hoveredComps[i].attributes.active) {
            colorSym = [194, 194, 194, 1]
          } else {
            colorSym = [240, 240, 240, 1]
          }

          hoveredComps[i].symbol = new SimpleMarkerSymbol({
            color: colorSym,
            size: px,
            angle: hoveredComps[i].symbol.angle,
            style: hoveredComps[i].symbol.style,
            outline: {
              color: [255, 255, 255],
              width: hoveredComps[i].symbol.outline.width
            }
          })
        }
      })
    },
    showhidevaluations() {
      const vm = this
      if (vm.isvaluations) {
        for (let i = 1; i < vm.currentMapView.graphics.items.length; i++) {
          vm.currentMapView.graphics.items[i].visible = true
        }
        vm.assetGraphicView.visible = true
        if (vm.sketchgraphview) {
          document.getElementById('poly_container').style.display = 'block'
        }
      } else {
        for (let i = 1; i < vm.currentMapView.graphics.items.length; i++) {
          vm.currentMapView.graphics.items[i].visible = false
        }
        vm.assetGraphicView.visible = false
        if (vm.sketchgraphview) {
          document.getElementById('poly_container').style.display = 'none'
        }
      }
    },
    showhideportfolio() {
      const vm = this
      if (vm.isportfolio && vm.currentAssets.data.length !== 0) {
        vm.portassetGraphicView.visible = true
        vm.activetypolegend = true
      } else {
        vm.portassetGraphicView.visible = false
        vm.activetypolegend = false
      }
    },
    addValuationControls() {
      const vm = this
      loadModules(
        [
          'esri/Color',
          'esri/layers/GraphicsLayer',
          'esri/geometry/Circle',
          'esri/geometry/Point',
          'esri/geometry/Polygon',
          'esri/geometry/Polyline',
          'esri/geometry/support/geodesicUtils',
          'esri/Graphic',
          'esri/symbols/SimpleFillSymbol',
          'esri/symbols/SimpleLineSymbol',
          'esri/symbols/SimpleMarkerSymbol',
          'esri/widgets/Sketch',
          'esri/widgets/Sketch/SketchViewModel',
          'esri/core/watchUtils'
        ], { css: true }
      ).then(
        ([
          Color,
          GraphicsLayer,
          Circle,
          Point,
          Polygon,
          Polyline,
          geodesicUtils,
          Graphic,
          SimpleFillSymbol,
          SimpleLineSymbol,
          SimpleMarkerSymbol,
          Sketch,
          SketchViewModel,
          watchUtils
        ]) => {
          // #region Drag - expand / reduce circle
          vm.currentMapView.on('drag', function(evt) {
            if (evt.action === 'start') {
              vm.dragShape = false
              vm.toolShape = undefined
              vm.axisShape = undefined
              vm.currentMapView.hitTest(evt).then((resp) => {
                if (
                  resp.results[0].graphic &&
                  resp.results[0].graphic.geometry &&
                  resp.results[0].graphic.geometry.type === 'point' &&
                  resp.results[0].graphic.attributes.tool
                ) {
                  evt.stopPropagation()
                  vm.currentMapView.graphics.remove(vm.centerGraphicval)
                  vm.toolShape = resp.results[0].graphic.attributes.tool
                  vm.axisShape = resp.results[0].graphic.attributes.axis
                  vm.dragShape = true
                }
              })
            } else if (evt.action === 'update' && vm.centerGraphicval && vm.dragShape) {
              var tempGeometry = vm.currentMapView.toMap(evt)
              var newPoint = new Point({
                geodesic: true,
                longitude: tempGeometry.longitude,
                latitude: tempGeometry.latitude
              })
              evt.stopPropagation()
              vm.currentMapView.graphics.remove(vm.centerGraphicval)
              if (vm.edgeNPointGraphic) {
                vm.currentMapView.graphics.remove(vm.edgeNPointGraphic)
              }
              if (vm.edgeSPointGraphic) {
                vm.currentMapView.graphics.remove(vm.edgeSPointGraphic)
              }
              if (vm.edgeWPointGraphic) {
                vm.currentMapView.graphics.remove(vm.edgeWPointGraphic)
              }
              if (vm.edgeEPointGraphic) {
                vm.currentMapView.graphics.remove(vm.edgeEPointGraphic)
              }
              vm.currentMapView.surface.style.cursor = vm.toolShape === 'move' ? 'pointer' : vm.axisShape === 'y' ? 'row-resize' : 'col-resize'
              vm.currentMapView.graphics.remove(vm.centerGraphicValuation)
              vm.centerGraphicValuation = new Graphic({
                geometry: vm.toolShape === 'move' ? newPoint : vm.centerGraphicval.geometry.center,
                symbol: new SimpleMarkerSymbol({
                  color: 'white',
                  style: 'x',
                  size: 7,
                  outline: {
                    color: [136, 150, 0],
                    width: '2px'
                  }
                }),
                attributes: {
                  tool: 'move'
                }
              })
              // todo?
              vm.currentMapView.graphics.add(vm.centerGraphicValuation)

              if (vm.rings_search[0].length === 0) {
                var newRadius = parseInt(
                  geodesicUtils.geodesicLengths(
                    [
                      new Polyline({
                        paths: [
                          [vm.centerGraphicval.geometry.center.longitude, vm.centerGraphicval.geometry.center.latitude],
                          [tempGeometry.longitude, tempGeometry.latitude]
                        ],
                        spatialReference: { wkid: 4326 }
                      })
                    ],
                    'meters'
                  )
                )
                if (newRadius > 1500) {
                  newRadius = 1500
                }
                vm.centerGraphicval = new Graphic(
                  new Circle({
                    center: vm.toolShape === 'move' ? newPoint : vm.centerGraphicval.geometry.center,
                    radius: vm.toolShape === 'move' ? vm.currentFilterValuations.more_filters.search_radius : newRadius,
                    radiusUnit: 'meters',
                    geodesic: true,
                    attributes: { searchBy: 'circle' }
                  }),
                  new SimpleFillSymbol(
                    SimpleFillSymbol.STYLE_SOLID,
                    new SimpleLineSymbol(SimpleLineSymbol.STYLE_DASHDOT, new Color([216, 175, 70]), 2),
                    new Color([216, 175, 70, 0.15])
                  )
                )

                vm.edgeNPointGraphic = new Graphic({
                  geometry: new Point({
                    longitude: vm.toolShape === 'move' ? tempGeometry.longitude : vm.currentFilterValuations.c_longitud,
                    latitude: vm.centerGraphicval.geometry.extent.ymax
                  }),
                  symbol: new SimpleMarkerSymbol({
                    color: 'white',
                    size: 7,
                    outline: {
                      color: [136, 150, 0],
                      width: '1px'
                    }
                  }),
                  attributes: {
                    tool: 'reshape',
                    axis: 'y'
                  }
                })
                vm.edgeSPointGraphic = new Graphic({
                  geometry: new Point({
                    longitude: vm.toolShape === 'move' ? tempGeometry.longitude : vm.currentFilterValuations.c_longitud,
                    latitude: vm.centerGraphicval.geometry.extent.ymin
                  }),
                  symbol: new SimpleMarkerSymbol({
                    color: 'white',
                    size: 7,
                    outline: {
                      color: [136, 150, 0],
                      width: '1px'
                    }
                  }),
                  attributes: {
                    tool: 'reshape',
                    axis: 'y'
                  }
                })
                vm.edgeWPointGraphic = new Graphic({
                  geometry: new Point({
                    longitude: vm.centerGraphicval.geometry.extent.xmin,
                    latitude: vm.toolShape === 'move' ? tempGeometry.latitude : vm.currentFilterValuations.c_latitud
                  }),
                  symbol: new SimpleMarkerSymbol({
                    color: 'white',
                    size: 7,
                    outline: {
                      color: [136, 150, 0],
                      width: '1px'
                    }
                  }),
                  attributes: {
                    tool: 'reshape'
                  }
                })
                vm.edgeEPointGraphic = new Graphic({
                  geometry: new Point({
                    longitude: vm.centerGraphicval.geometry.extent.xmax,
                    latitude: vm.toolShape === 'move' ? tempGeometry.latitude : vm.currentFilterValuations.c_latitud
                  }),
                  symbol: new SimpleMarkerSymbol({
                    color: 'white',
                    size: 7,
                    outline: {
                      color: [136, 150, 0],
                      width: '1px'
                    }
                  }),
                  attributes: {
                    tool: 'reshape'
                  }
                })
              } else {
                vm.translatePolygon(vm.centerGraphicval.geometry.centroid, newPoint, vm.rings_search)
                vm.centerGraphicval = new Graphic(
                  new Polygon({
                    centroid: newPoint,
                    rings: vm.rings_search,
                    geodesic: true,
                    attributes: { searchBy: 'polygon' }
                  }),
                  new SimpleFillSymbol(
                    SimpleFillSymbol.STYLE_SOLID,
                    new SimpleLineSymbol(SimpleLineSymbol.STYLE_DASHDOT, new Color([216, 175, 70]), 2),
                    new Color([216, 175, 70, 0.15])
                  )
                )
                vm.currentFilterValuations.c_longitud = vm.centerGraphicval.geometry.centroid.longitude
                vm.currentFilterValuations.c_latitud = vm.centerGraphicval.geometry.centroid.latitude
              }
              vm.currentMapView.graphics.add(vm.centerGraphicval)
              if (vm.edgeNPointGraphic) {
                vm.currentMapView.graphics.add(vm.edgeNPointGraphic)
              }
              if (vm.edgeSPointGraphic) {
                vm.currentMapView.graphics.add(vm.edgeSPointGraphic)
              }
              if (vm.edgeWPointGraphic) {
                vm.currentMapView.graphics.add(vm.edgeWPointGraphic)
              }
              if (vm.edgeEPointGraphic) {
                vm.currentMapView.graphics.add(vm.edgeEPointGraphic)
              }
            } else if (evt.action === 'end' && vm.dragShape) {
              if (vm.rings_search[0].length === 0 && vm.toolShape === 'move') {
                vm.currentFilterValuations.c_longitud = vm.centerGraphicval.geometry.centroid.longitude
                vm.currentFilterValuations.c_latitud = vm.centerGraphicval.geometry.centroid.latitude
                vm.SearchComps()
              } else if (vm.rings_search[0].length === 0) {
                // vm.$root.$emit('UpdateCircleRadius__' + vm.namespaceKey, vm.centerGraphicval.geometry.radius)
                vm.currentFilterValuations.more_filters.search_radius = Math.round(vm.centerGraphicval.geometry.radius)
                vm.SearchComps()
              }
              if (vm.rings_search[0].length !== 0) {
                vm.searchByPolygon(vm.centerGraphicval, false, vm.toolShape === 'move')
              }
              vm.dragShape = false
              vm.toolShape = undefined
              vm.axisShape = undefined
            }
          })
          // #endregion
          // #region Sketch - botones círculo / polígono

          if (vm.sketchgraphview === null) {
            vm.sketchgraphview = new GraphicsLayer()

            var sketchgraph = new SketchViewModel({
              layer: vm.sketchgraphview,
              view: vm.currentMapView,
              updateOnGraphicClick: false,
              defaultUpdateOptions: {
                // set the default options for the update operations
                toggleToolOnClick: false // only reshape operation will be enabled
              },
              pointSymbol: {
                type: 'simple-marker',
                style: 'circle',
                size: 6,
                color: [216, 175, 70],
                outline: {
                  color: [216, 175, 70],
                  width: '1px'
                }
              },
              polygonSymbol: {
                type: 'simple-fill',
                color: [216, 175, 70, 0.2],
                outline: {
                  color: [216, 175, 70],
                  width: '2px'
                }
              }
            })

            var sketch = new Sketch({
              view: vm.currentMapView,
              layer: vm.sketchgraphview,
              container: 'poly_container',
              viewModel: sketchgraph
            })
          }

          sketch.on('create', function(event) {
            if (event.state === 'complete') {
              if (event.tool === 'circle') {
                vm.rings_search = [
                  []
                ]
                vm.currentFilterValuations.c_latitud = event.graphic.geometry.centroid.latitude
                vm.currentFilterValuations.c_longitud = event.graphic.geometry.centroid.longitude
                vm.currentFilterValuations.c_polygon = [
                  []
                ]
                vm.currentFilterValuations.more_filters.search_radius = Math.round(event.graphic.geometry.extent.width / 2)
                vm.SearchComps()
              } else if (event.tool === 'polygon') {
                vm.currentFilterValuations.c_latitud = event.graphic.geometry.centroid.latitude
                vm.currentFilterValuations.c_longitud = event.graphic.geometry.centroid.longitude
                // vm.currentFilterValuations.more_filters.search_radius = Math.round(event.graphic.geometry.extent.width / 2)
                vm.searchByPolygon(event.graphic, true, true)
              }
            }
          })
          // #endregion

          vm.showhidevaluations()
        }
      )
    },
    translatePolygon(startPoint, currPoint, rings) {
      var dx = currPoint.x - startPoint.x
      var dy = currPoint.y - startPoint.y
      rings.forEach((ring) => {
        if (Array.isArray(ring[0])) {
          ring.forEach((coord) => {
            coord[0] += dx
            coord[1] += dy
          })
        } else {
          ring[0] += dx
          ring[1] += dy
        }
      })
    },
    searchByPolygon(graphic, convertogeo, keepFilters) {
      var vm = this
      loadModules([
        'esri/geometry/support/webMercatorUtils',
        'esri/geometry/Polyline',
        'esri/geometry/support/geodesicUtils'
      ], { css: true }).then(([webMercatorUtils, Polyline, geodesicUtils]) => {
        var radius = 0
        vm.longitude = graphic.geometry.centroid.longitude
        vm.latitude = graphic.geometry.centroid.latitude
        if (convertogeo) {
          vm.rings_search = webMercatorUtils.webMercatorToGeographic({
            rings: graphic.geometry.rings,
            geodesic: true,
            spatialReference: { wkid: 4326 }
          }).rings
        } else {
          vm.rings_search = graphic.geometry.rings
        }
        console.log(vm.rings_search)
        _.forEach(vm.rings_search[0], function items(item) {
          var distance = geodesicUtils.geodesicLengths([new Polyline({
            paths: [
              [graphic.geometry.centroid.longitude, graphic.geometry.centroid.latitude],
              [item[0], item[1]]
            ],
            spatialReference: { wkid: 4326 }
          })], 'meters')
          if (distance > radius) {
            radius = distance
          }
        })
        if (radius > 0) {
          vm.currentFilterValuations.c_polygon = vm.rings_search
          vm.currentFilterValuations.more_filters.search_radius = Math.round(radius[0])
        }
        vm.SearchComps()
      })
    },
    SearchComps() {
      // hacer un set del currentfilter, luego cambiar la posicion y debería ir solo todo
      const vm = this
      vm.loading = true
      vm.$store.dispatch('valuations/setfilter', vm.currentFilterValuations).then(() => {
        const place = {
          geometry: {
            location: {
              lat: function() {
                return vm.currentFilterValuations.c_latitud
              },
              lng: function() {
                return vm.currentFilterValuations.c_longitud
              }
            }
          },
          formatted_address: 'frommapclick'
        }
        // debugger
        vm.$store.dispatch('location/searchlocations', place).then(() => {
          const location = {
            lat: parseFloat(vm.currentFilterValuations.c_latitud),
            lng: parseFloat(vm.currentFilterValuations.c_longitud)
          }
          var geocoder = new vm.google.maps.Geocoder()
          vm.loading = false
          geocoder.geocode({ 'location': location }, function(results, status) {
            if (status === vm.google.maps.GeocoderStatus.OK) {
              const loc = results[0]
              vm.$root.$emit('locationaddressfrommap', loc)
            } else {
              console.log('address not found')
              // debugger
            }
          })
        }).catch(() => {
          vm.loading = false
          vm.$message({
            message: vm.$t('locationSelector.invalidlocation'),
            type: 'error'
          })
        })
      }).catch(() => {
        vm.loading = false
        vm.$message({
          message: vm.$t('valuations.errorcomparbles'),
          type: 'error'
        })
      })
    },
    selectRankingItem(element) {
      const vm = this
      loadModules(['esri/layers/FeatureLayer', 'esri/Graphic'], { css: true }).then(([FeatureLayer, Graphic]) => {
        if (vm.VectorLayerlegend === undefined) { return }
        if (vm.currentHoveredLayer !== null) { vm.currentHoveredLayer.graphics.removeAll() }
        vm.loading = true
        var urlfeature = vm.getRankingQueryString(element.level)
        const featureLayer = new FeatureLayer({
          url: urlfeature
        })
        var sqlExpression = ''
        sqlExpression += 'objectid = ' + element.objectid
        // const currentgeom = vm.currentMapView.extent
        var query = {
          outFields: ['objectid'],
          returnGeometry: true,
          where: sqlExpression // ,
          // geometry: currentgeom
        }
        // debugger
        featureLayer.queryFeatures(query).then(function(result) {
          if (vm.currentHoveredLayer) { vm.currentHoveredLayer.graphics.removeAll() }
          if (result.features.length > 0) {
            var layer = result.features[0]
            vm.nextGeoLevel = parseInt(element.level)
            vm.longitude = layer.geometry.centroid.longitude
            vm.latitude = layer.geometry.centroid.latitude
            const place = {
              geometry: {
                location: {
                  lat: function() {
                    return layer.geometry.centroid.latitude
                  },
                  lng: function() {
                    return layer.geometry.centroid.longitude
                  }
                }
              },
              formatted_address: element.label
            }
            // debugger
            vm.$store.dispatch('location/searchlocations', place)
          }
        })
      })
      vm.loading = false
    },
    hoverRankingData(element) {
      const vm = this
      loadModules(['esri/layers/FeatureLayer', 'esri/Graphic'], { css: true }).then(([FeatureLayer, Graphic]) => {
        if (vm.VectorLayerlegend === undefined) { return }
        if (vm.currentHoveredLayer !== null) { vm.currentHoveredLayer.graphics.removeAll() }
        vm.loading = true

        var urlfeature = vm.getRankingQueryString(element.level)
        const featureLayer = new FeatureLayer({
          url: urlfeature
        })
        var sqlExpression = ''
        sqlExpression += 'objectid = ' + element.objectid
        const currentgeom = vm.currentMapView.extent
        var query = {
          outFields: ['objectid'],
          returnGeometry: true,
          where: sqlExpression,
          geometry: currentgeom
        }
        featureLayer.queryFeatures(query).then(function(result) {
          result.features.forEach(function(feature) {
            var g = new Graphic({
              geometry: feature.geometry,
              attributes: feature.attributes,
              symbol: {
                type: 'simple-fill',
                color: [0, 153, 153, 0.15],
                outline: {
                  width: 2,
                  color: [0, 153, 153]
                }
              }
            })
            vm.currentHoveredLayer.graphics.removeAll()
            if (!vm.removeHover) { vm.currentHoveredLayer.graphics.add(g) }
          })
          vm.loading = false
        })
      })
      vm.loading = false
    },
    removeRankingLevel() {
      var vm = this
      if (vm.currentHoveredLayer !== null) { vm.currentHoveredLayer.graphics.removeAll() }
    },
    setzoombylevel() {
      const vm = this
      if (vm.geolevelselected === null || vm.geolevelselected === undefined || vm.geolevelselected === '' || vm.VectorLayerlegend === null || vm.VectorLayerlegend === undefined) {
        return
      }
      let levelzoom = vm.VectorLayerlegend.legends.filter((item) => item.level === 'L' + vm.geolevelselected.level)
      if (vm.lockablemap && vm.maplocked) {
        // same zoom
        var tileStyle = JSON.parse(JSON.stringify(vm.selectedmapvisualization))
        levelzoom = tileStyle.legends.filter((item) => item.level === 'L' + vm.geolevelselected.level)
      }
      if (levelzoom.length > 0) {
        levelzoom = levelzoom[0]
      } else {
        // levelzoom = vm.VectorLayerlegend.legends[0]
        vm.$message({
          showClose: true,
          message: vm.$t('maps.level-visualization-not-found'),
          type: 'warning'
        })
        return
      }
      if (levelzoom.maxzoom > 15) {
        levelzoom.maxzoom = 12
      }
      vm.currentMapView.zoom = levelzoom.maxzoom
      vm.currentMapView.center = [vm.position.longitude, vm.position.latitude]
    },
    getRankingQueryString(extLvl) {
      var vm = this
      var level = vm.geolevelselected.level
      if (extLvl !== null && extLvl !== undefined && extLvl !== '') { level = parseInt(extLvl) }
      let nivel = 1
      // const mapversion = '_DEV'
      const mapversion = ''
      let urlfeaturelayer = vm.servergis + '/server/rest/services/Spain/Query_ES' + mapversion + '/MapServer/'
      if (vm.lastcountry === 'Italia') {
        urlfeaturelayer = vm.servergis + '/server/rest/services/Italia/Query_IT' + mapversion + '/MapServer/'
        if (level === 0) {
          return ''
        } else if (level === 1) {
          nivel = 0
        } else if (level === 2) {
          nivel = 1
        } else if (level === 3) {
          nivel = 2
        } else if (level === 4) {
          nivel = 3
        } else if (level === 5) {
          nivel = 4
        } else if (level === 8) {
          return ''
        }
      }
      return urlfeaturelayer + nivel
    },
    cambiarBasemap(newBase) {
      this.basemapValue = newBase
      this.currentMap.basemap = newBase
      this.map_type_popover = false
      this.loading = false
    },
    applymapStyle() {
      console.log('APPLYING MAP STYLES')
      this.loading = true
      const vm = this
      var countryname = 'Italia'
      if (vm.selectedmap.mapvisualizationval === 'satellite_view') {
        vm.cambiarBasemap('satellite')
        if (vm.currentVectorLayer) {
          vm.currentVectorLayer.opacity = 0
          vm.legendstops = []
          return
        }
      } else if (vm.selectedmap.mapvisualizationval === 'wms_view') {
        // vm.cambiarBasemap('wms')
        // debugger
      } else {
        vm.cambiarBasemap('topo-vector')
        if (vm.currentVectorLayer) {
          vm.currentVectorLayer.opacity = 7
        }
      }

      loadModules(['esri/layers/VectorTileLayer', 'esri/identity/IdentityManager'], { css: true })
        .then(([VectorTileLayer, IdentityManager]) => {
          if (!vm.tokenregister) {
            IdentityManager.registerToken({
              server: vm.servergis + '/portal/sharing/rest',
              token: vm.maptoken
            })
            vm.tokenregister = true
          }

          var tileStyle = JSON.parse(JSON.stringify(vm.selectedmapvisualization))
          if (!tileStyle) return
          if (tileStyle.style.glyphs.indexOf('italia_VT_') > 0) {
            var newmap = tileStyle.style.glyphs.substr(tileStyle.style.glyphs.indexOf('_VT_'))
            var replacemap = newmap.substr(0, newmap.indexOf('/'))
            var replaceto = ''
            if (replacemap.indexOf('_DEV') > 0) {
              replaceto = replacemap.replace('_DEV', '_noZoom_DEV')
            } else {
              replaceto = replacemap + '_noZoom'
              // fix temporal
              replaceto = replacemap + '_noZoom_DEV'
            }
            vm.lockablemap = true
            vm.maplocked = false
            // change to italia_VT_Affordability_Illimity_DEV
            /*
            tileStyle.style.glyphs = tileStyle.style.glyphs.replace('italia_VT_Affordability', 'italia_VT_Affordability_Illimity_DEV')
            tileStyle.style.sprite = tileStyle.style.sprite.replace('italia_VT_Affordability', 'italia_VT_Affordability_Illimity_DEV')
            tileStyle.style.sources.esri.url = tileStyle.style.sources.esri.url.replace('italia_VT_Affordability', 'italia_VT_Affordability_Illimity_DEV')
            */
            tileStyle.style.glyphs = tileStyle.style.glyphs.replace(replacemap, replaceto)
            tileStyle.style.sprite = tileStyle.style.sprite.replace(replacemap, replaceto)
            tileStyle.style.sources.esri.url = tileStyle.style.sources.esri.url.replace(replacemap, replaceto)
          } else {
            vm.lockablemap = false
            vm.maplocked = false
          }
          if (tileStyle !== null) {
            console.log(tileStyle)
            vm.VectorLayerlegend = tileStyle
            tileStyle = tileStyle.style
            // }
          } else {
            tileStyle = null
            vm.legendlevel = '---'
            vm.legendstops = []
            // Se comprueba que estamos en la vista del mapa, esto provocaba fallos en los charts TODO
            if (this.visualizationid === 0) {
              vm.$message({
                showClose: true,
                message: vm.$t('maps.visualization-not-found'),
                type: 'warning'
              })
            }
          }
          vm.lastcountry = countryname
          vm.legendtitle = vm.selectedmap.mapvisualizationtitle_clean
          vm.typolegend = vm.selectedmap.mapvisualizationtitle.length > 1 ? vm.$t(vm.selectedmap.mapvisualizationtitle[1]) : ''
          var visu = new VectorTileLayer({
            style: tileStyle,
            opacity: 0.7
          })
          vm.currentMap.remove(vm.currentVectorLayer)
          vm.currentVectorLayer = visu
          vm.currentMap.add(vm.currentVectorLayer, 0)

          // Pintar limites del nivel superior
          vm.currentMap.remove(vm.currentVectorLayerSuperior)
          vm.currentVectorLayerSuperior = new VectorTileLayer({
            url: vm.servergis + '/server/rest/services/Hosted/' + countryname + '_VT_boundary/VectorTileServer/resources/styles/root.json',
            opacity: 0.5
          })
          vm.currentMap.add(vm.currentVectorLayerSuperior, 1)

          vm.generatelegend()

          vm.loading = false
        })
    },
    lockmapzoom() {
      const vm = this
      if (!vm.lockablemap) {
        return
      }
      vm.maplocked = !vm.maplocked
      if (!vm.maplocked) {
        vm.applymapStyle()
      } else {
        var tileStyle = JSON.parse(JSON.stringify(vm.selectedmapvisualization))
        const zoom = vm.getLegendLevel()
        tileStyle.legends.forEach(item => {
          if (item.level === 'L' + zoom) {
            item.minzoom = 1
            item.maxzoom = 10000
          } else {
            item.minzoom = 0
            item.maxzoom = 0
          }
        })
        tileStyle.style.layers.forEach(item => {
          if (item.id.indexOf('L' + zoom) > 0) {
            item.minzoom = 1
            item.maxzoom = 10000
          } else {
            item.id = item.id + 'unknow'
            item['source-layer'] = item['source-layer'] + 'unknow'
            item.minzoom = 0
            item.maxzoom = 0
          }
        })
        if (tileStyle !== null) {
          vm.VectorLayerlegend = tileStyle
          tileStyle = tileStyle.style

          // if geolevel selected != zoom , change geolevel
          const actlevel = vm.geolevels.filter(item => item.level === vm.getLegendLevel())
          if (actlevel.length > 0) {
            vm.$store.dispatch('location/setgeolevel', actlevel[0])
          }
          // }
        } else {
          tileStyle = null
          vm.legendlevel = '---'
          vm.legendstops = []
          // Se comprueba que estamos en la vista del mapa, esto provocaba fallos en los charts TODO
          if (this.visualizationid === 0) {
            vm.$message({
              showClose: true,
              message: vm.$t('maps.visualization-not-found'),
              type: 'warning'
            })
          }
        }
        loadModules(['esri/layers/VectorTileLayer', 'esri/identity/IdentityManager'], { css: true })
          .then(([VectorTileLayer, IdentityManager]) => {
            if (!vm.tokenregister) {
              IdentityManager.registerToken({
                server: vm.servergis + '/portal/sharing/rest',
                token: vm.maptoken
              })
              vm.tokenregister = true
            }
            // debugger
            /*
            tileStyle.glyphs = tileStyle.glyphs.replace('italia_VT_Affordability', 'italia_VT_Affordability_Illimity_DEV')
            tileStyle.sprite = tileStyle.sprite.replace('italia_VT_Affordability', 'italia_VT_Affordability_Illimity_DEV')
            tileStyle.sources.esri.url = tileStyle.sources.esri.url.replace('italia_VT_Affordability', 'italia_VT_Affordability_Illimity_DEV')
            */
            var newmap = tileStyle.glyphs.substr(tileStyle.glyphs.indexOf('_VT_'))
            var replacemap = newmap.substr(0, newmap.indexOf('/'))
            var replaceto = ''
            if (replacemap.indexOf('_DEV') > 0) {
              replaceto = replacemap.replace('_DEV', '_noZoom_DEV')
            } else {
              replaceto = replacemap + '_noZoom'
              // fix temporal
              replaceto = replacemap + '_noZoom_DEV'
            }
            tileStyle.glyphs = tileStyle.glyphs.replace(replacemap, replaceto)
            tileStyle.sprite = tileStyle.sprite.replace(replacemap, replaceto)
            tileStyle.sources.esri.url = tileStyle.sources.esri.url.replace(replacemap, replaceto)

            vm.legendtitle = vm.selectedmap.mapvisualizationtitle_clean
            vm.typolegend = vm.selectedmap.mapvisualizationtitle.length > 1 ? vm.$t(vm.selectedmap.mapvisualizationtitle[1]) : ''
            var visu = new VectorTileLayer({
              style: tileStyle,
              opacity: 0.7
            })
            vm.currentMap.remove(vm.currentVectorLayer)
            vm.currentVectorLayer = visu
            vm.currentMap.add(vm.currentVectorLayer, 0)
          })
      }
    },
    getQueryString() {
      var vm = this
      const levellegend = vm.VectorLayerlegend.legends.filter((item) => vm.currentMapView.zoom > item.minzoom && vm.currentMapView.zoom <= item.maxzoom)
      if (levellegend.length === 0) { return '' }
      let nivel = 1
      const urlfeaturelayer = vm.servergis + '/server/rest/services/Italia/Query_IT/MapServer/'
      /*
      if (levellegend.level === 'L0') {
        return ''
      } else if (levellegend.level === 'L1') {
        nivel = 0
      } else if (levellegend.level === 'L2') {
        nivel = 1
      } else if (levellegend.level === 'L3') {
        nivel = 2
      } else if (levellegend.level === 'L4') {
        nivel = 3
      } else if (levellegend.level === 'L5') {
        nivel = 4
      } else if (levellegend.level === 'L8') {
        return ''
      }
      */
      if (vm.geolevelselected !== null) {
        if (vm.geolevelselected.level === 0) {
          nivel = 0
        } else if (vm.geolevelselected.level === 1) {
          nivel = 0
        } else if (vm.geolevelselected.level === 2) {
          nivel = 1
        } else if (vm.geolevelselected.level === 3) {
          nivel = 2
        } else if (vm.geolevelselected.level === 4) {
          nivel = 3
        } else if (vm.geolevelselected.level === 5) {
          nivel = 4
        } else if (vm.geolevelselected.level > 5) {
          nivel = 4
        }
      }

      // debugger
      return urlfeaturelayer + nivel
    },
    filterMapData() {
      const vm = this
      loadModules(['esri/layers/FeatureLayer', 'esri/Graphic'], { css: true }).then(([FeatureLayer, Graphic]) => {
        // debugger
        if (vm.VectorLayerlegend === undefined) { return }
        if (vm.mapFilters.length === 0) {
          vm.currentFilterLayer.graphics.removeAll()
          return
        }
        vm.loading = true
        var urlfeature = vm.getQueryString()
        if (urlfeature === undefined || urlfeature === '') { return }

        const featureLayer = new FeatureLayer({
          url: urlfeature
        })
        let sqlExpression = ''
        vm.mapFilters.forEach(item => {
          sqlExpression += sqlExpression === '' ? '' : ' and '
          sqlExpression += item.id + ' >= ' + item.values[0] + ' and ' + item.id + ' <= ' + item.values[1]
        })
        const currentgeom = vm.currentMapView.extent
        var query = {
          outFields: ['*'], // si esto lo reducimos ira mas rapido, en lugar de * poner lo que queramos mostrar
          returnGeometry: true,
          where: sqlExpression,
          geometry: currentgeom
        }
        featureLayer.queryFeatures(query).then(function(result) {
          vm.currentFilterLayer.graphics.removeAll()
          if (result.features === undefined || result.features === null || result.features.length === 0) {
            vm.$message({
              showClose: true,
              message: 'No coincidences with this filters',
              type: 'warning'
            })
          }
          result.features.forEach(function(feature) {
            var g = new Graphic({
              geometry: feature.geometry,
              attributes: feature.attributes,
              symbol: {
                type: 'simple-fill',
                color: [234, 196, 40, 0.05],
                outline: {
                  width: 2,
                  color: [234, 196, 40]
                }
              }
            })
            vm.currentFilterLayer.graphics.add(g)
          })
          vm.loading = false
        })
      })
      vm.loading = false
    },
    generatelegend() {
      const vm = this
      if (vm.VectorLayerlegend === null || vm.VectorLayerlegend === undefined) {
        vm.legendlevel = '---'
        vm.legendtitle = '---'
        return
      }
      let levellegend = vm.VectorLayerlegend.legends.filter((item) => vm.currentMapView.zoom > item.minzoom && vm.currentMapView.zoom <= item.maxzoom)
      vm.getLegendLevel()

      if (levellegend.length === 0) {
        this.loading = false
        return
      }
      levellegend = levellegend[0]
      // vm.$root.$emit('UpdatedMapZoom_', vm.legendlevel)

      var unit = vm.VectorLayerlegend.unit

      if (unit === 'months') {
        unit = vm.$t('assetData.months')
      } else if (unit === '€\\sqm') {
        unit = vm.$t('marketplace.eur-sqm')
      }

      vm.legendstops = levellegend.fields.map((item) => {
        return {
          label: item[0],
          color: item[1],
          unit: unit
        }
      })

      this.loading = false
    },
    getLegendLevel() {
      var vm = this
      let levellegend = this.VectorLayerlegend.legends.filter((item) => this.currentMapView.zoom > item.minzoom && this.currentMapView.zoom <= item.maxzoom)

      if (levellegend.length === 0) {
        this.loading = false
        return
      }
      var level = 0
      levellegend = levellegend[0]
      switch (levellegend.level) {
        case 'L8':
          vm.legendlevel = vm.$t('assetData.zipcode')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_08
          level = 8
          break
        case 'L7':
          vm.legendlevel = vm.$t('maps.census')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_07
          level = 7
          break
        case 'L5':
          if (vm.lastcountry === 'Italia' && (vm.mapvisualizationval.includes('trans_sale_em2') || vm.mapvisualizationval.includes('trans_rent_em2'))) {
            vm.legendlevel = 'OMI area' // TRADUCIR
          } else {
            vm.legendlevel = vm.$t('maps.census-district')
          }
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_05
          level = 5
          break
        case 'L4':
          vm.legendlevel = vm.$t('infra-municipality')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_04
          level = 4
          break
        case 'L3':
          vm.legendlevel = vm.$t('maps.municipality')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_03
          level = 3
          break
        case 'L2':
          vm.legendlevel = vm.$t('maps.province')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_02
          level = 2
          break
        case 'L1':
          vm.legendlevel = vm.$t('assetData.region')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_01
          level = 1
          break
        case 'L0':
          vm.legendlevel = vm.$t('maps.country')
          vm.mapLevelDate = vm.selectedmap.mapvisualizationobject.date_00
          level = 0
          break
        default:
          vm.legendlevel = '---'
          vm.mapLevelDate = ''
          break
      }

      return level
    },
    centermapposition() {
      const vm = this
      if (vm.currentMap === null) return
      if (this.position.latitude !== null) {
        loadModules(
          [
            'esri/Color',
            'esri/geometry/Circle',
            'esri/geometry/Point',
            'esri/geometry/Polygon',
            'esri/Graphic',
            'esri/symbols/SimpleFillSymbol',
            'esri/symbols/SimpleLineSymbol',
            'esri/layers/FeatureLayer',
            'esri/layers/GraphicsLayer'
          ], { css: true }
        ).then(([Color, Circle, Point, Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol, FeatureLayer, GraphicsLayer]) => {
          const centerPoint = new Point({
            longitude: vm.position.longitude,
            latitude: vm.position.latitude,
            spatialReference: {
              wkid: 4326
            }
          })

          const sym = {
            type: 'picture-marker',
            url: require('@/assets/brains_icons/pingeneral.svg'),
            width: '32px',
            height: '32px',
            yoffset: '15px'
          }

          vm.centerGraphic = new Graphic({
            geometry: centerPoint,
            symbol: sym,
            attributes: {
              tool: 'move'
            }
          })

          vm.currentMapView.graphics.removeAll()
          vm.currentMapView.graphics.add(vm.centerGraphic)
          vm.currentMapView.center = [centerPoint.longitude, centerPoint.latitude]
          vm.$store.dispatch('maps/setmappoint', vm.currentMapView.center)
        })
      }
    },
    generatelegendzoom() {
      if (this.currentMapView.zoom % 1 === 0) {
        // Se evita generar datos de la leyenda en caso de estar viendo el mapa especial Vista Satelite
        if (this.mapvisualizationval !== 'satellite_view' && this.mapvisualizationval !== 'wms_view') {
          this.generatelegend()
        } else {
          // debugger
          this.getLegendLevel()
        }
      }
    },
    createmap() {
      const vm = this
      const centermappoint = [window._env_.VUE_APP_DEFAULT_LOCATION_LONG, window._env_.VUE_APP_DEFAULT_LOCATION_LAT]
      loadModules(
        [
          'esri/config',
          'esri/identity/IdentityManager',
          'esri/layers/GraphicsLayer',
          'esri/Map',
          'esri/views/MapView',
          'esri/core/watchUtils',
          'esri/layers/FeatureLayer',
          'esri/layers/WMSLayer',
          'esri/geometry/Extent',
          'esri/geometry/SpatialReference',
          'esri/layers/support/WMSSublayer',
          'esri/core/urlUtils',
          'esri/Basemap'
        ], { css: true }
      ).then(
        ([
          esriConfig,
          IdentityManager,
          GraphicsLayer,
          ArcGISMap,
          MapView,
          watchUtils,
          FeatureLayer,
          WMSLayer,
          Extend, SpatialReference, WMSSublayer, urlUtils, Basemap
        ]) => {
          console.log('createmap')

          vm.currentFilterLayer = new GraphicsLayer({
            graphics: []
          })
          vm.currentSelectedGeoLayer = new GraphicsLayer({
            graphics: []
          })
          vm.currentHoveredLayer = new GraphicsLayer({
            graphics: []
          })

          vm.assetGraphicView = new GraphicsLayer({
            graphics: [],
            title: 'comparablepoints',
            popupTemplate: {
              content: 'kk'
            }
          })

          vm.portassetGraphicView = new GraphicsLayer({
            graphics: [],
            title: 'assetpoints',
            popupTemplate: {
              content: 'pp'
            }
          })

          vm.currentMap = new ArcGISMap({
            basemap: vm.basemapValue,
            layers: [vm.currentFilterLayer, vm.currentHoveredLayer, vm.currentSelectedGeoLayer, vm.assetGraphicView, vm.portassetGraphicView]
          })
          var zoomLevel
          if (vm.$route.query.level) {
            switch (vm.$route.query.level) {
              case '0':
                zoomLevel = 6
                break
              case '1':
                zoomLevel = 7
                break
              case '2':
                zoomLevel = 8
                break
              case '3':
                zoomLevel = 9
                break
              default:
                zoomLevel = 6
                break
            }
          } else {
            zoomLevel = 6
          }

          vm.currentMapView = new MapView({
            container: 'viewDiv',
            map: vm.currentMap,
            center: centermappoint,
            constraints: {
              rotationEnabled: false
            },
            popup: {
              dockEnabled: false,
              dockOptions: {
                buttonEnabled: false,
                breakpoint: false
              },
              visibleElements: {
                closeButton: false
              },
              actions: []
            },
            // zoom: vm.getproperzoom()
            zoom: zoomLevel
          })

          vm.currentMapView.container.addEventListener('dragover', function(event) {
            vm.gsv_active = false
            event.preventDefault()
            event.dataTransfer.dropEffect = 'copyMove'
          })

          vm.currentMapView.container.addEventListener('drop', function(event) {
            vm.gsv_active = false
            const actpoint = vm.currentMapView.toMap({ x: event.layerX, y: event.layerY })
            event.preventDefault()
            vm.longitude = actpoint.longitude
            vm.latitude = actpoint.latitude
            window.open(
              'https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=' + actpoint.latitude + ',' + actpoint.longitude + '&heading=90&pitch=38&fov=80',
              'brainsre gsv'
            )
          })

          watchUtils.watch(vm.currentMapView, 'zoom', function() {
            if (Number.isInteger(this.zoom)) { vm.zoomMap = this.zoom }
            vm.generatelegendzoom()
          })

          vm.currentMapView.when(function() {
            vm.currentMapView.ui.move(['zoom'], 'bottom-left')
            vm.addValuationControls()
            vm.currentMapView.on('click', function(evt) {
              if (evt.button === 2) {
                evt.stopPropagation()
                const place = {
                  geometry: {
                    location: {
                      lat: function() {
                        return evt.mapPoint.latitude
                      },
                      lng: function() {
                        return evt.mapPoint.longitude
                      }
                    }
                  },
                  formatted_address: 'frommapclick'
                }
                vm.loading = true
                vm.$store.dispatch('location/searchlocations', place).then(() => {
                  const location = {
                    lat: parseFloat(evt.mapPoint.latitude),
                    lng: parseFloat(evt.mapPoint.longitude)
                  }
                  var geocoder = new vm.google.maps.Geocoder()
                  vm.loading = false
                  geocoder.geocode({ 'location': location }, function(results, status) {
                    if (status === vm.google.maps.GeocoderStatus.OK) {
                      const loc = results[0]
                      vm.$root.$emit('locationaddressfrommap', loc)
                    } else {
                      console.log('address not found')
                      // debugger
                    }
                  })
                }).catch(() => {
                  vm.loading = false
                  vm.$message({
                    message: vm.$t('locationSelector.invalidlocation'),
                    type: 'error'
                  })
                })
              } else {
                vm.currentMapView.hitTest(evt.screenPoint).then(function(response) {
                  var graphic = _.filter(response.results, function(item) {
                    return item.graphic.layer.title !== 'Layer' &&
                      item.graphic.id !== 'rankingLevel' &&
                      (item.graphic.id !== undefined ||
                        item.graphic.layer.title !== undefined)
                  })[0]
                  if (graphic === null || graphic === undefined) { return } else { graphic = graphic.graphic }
                  /*
                  if (evt.button === 0 && graphic.attributes && graphic.attributes.id === 'centerPin') {
                    vm.$root.$emit('ComparableCenterClicked')
                  }
                  */
                  /*
                  const findTerm = (term) => {
                    if (graphic.layer.title.includes(term)) {
                      return graphic.layer.title
                    }
                  }
                  */
                  // console.log(graphic)
                  // TODO: cambiar title por graphic.id ???
                  switch (graphic.layer.title) {
                    case 'comparablepoints':
                      comparablePoint()
                      break
                    case 'assetpoints':
                      comparablePoint()
                      break
                    case 'poispoints':
                      clickPoiPoint()
                      break
                      // case findTerm('GoalSeek'): parcelaCatastro(); break
                      // default: defaultClick(); break
                  }

                  function clickPoiPoint() {
                    return
                  }

                  function comparablePoint() {
                    const comparableid = graphic.attributes.id || graphic.attributes.iD_comparable || graphic.attributes.id_portfolio

                    if (vm.activeNav === 'valuation') {
                      vm.$root.$emit('ComparableClicked', comparableid)
                    } else if (vm.activeNav === 'portfolio') {
                      vm.$root.$emit('AssetClicked', comparableid)
                    }
                    /*
                    } else if (vm.$route.name === 'Portfolio') {
                      vm.$root.$emit('AssetClicked', comparableid)
                    } else {
                      vm.$parent.$parent.$children[2].$children[0].$children[2].$children[0].MapClickedComparable(comparableid)
                    }
                    */
                    vm.currentMapView.popup.close()
                  }

                  /*
                  function parcelaCatastro() {
                    vm.searchDataCatastroIdentify(evt.mapPoint)
                  }
                  */
                })
              }
            })
            vm.currentMapView.on('pointer-move', function(evt) {
              var screenPoint = {
                x: evt.x,
                y: evt.y
              }

              vm.currentMapView.hitTest(screenPoint).then(function(response) {
                if (vm.activeNav === 'valuation') {
                  // Se lanza un evento nada más entrar en el hover solo para eliminar de la lista de comparables el seleccionado antiguo
                  vm.$root.$emit('comparableValuationHoveredOut')
                  vm.removeHoveredComparablesStyle()

                  // ver si le puedo pasar el objeto completo en graphic buscando en currentComparables el item
                  // si es asi controlar si cambio o no para hacer otra busqueda y pasarselo al popup
                  const assethover = response.results.filter((u) => !!u.graphic.attributes && !!u.graphic.attributes.iD_comparable)
                  if (assethover.length > 0) {
                    var graphic = assethover[0].graphic
                    vm.setHoveredComparableStyle(graphic, true)
                    vm.$root.$emit('comparableValuationHovered', graphic.attributes.iD_comparable)

                    const asset = vm.currentComparables.filter(item => item.iD_comparable === graphic.attributes.iD_comparable)[0]
                    if (asset !== undefined) {
                      // graphic.attributes = asset
                      vm.currentMapView.popup.open({
                        location: { latitude: graphic.geometry.latitude, longitude: graphic.geometry.longitude },
                        features: [asset]
                      })
                    }
                  } else {
                    vm.currentMapView.popup.close()
                  }
                } else if (vm.activeNav === 'portfolio') {
                  vm.$root.$emit('comparableAssetHoveredOut')
                  vm.removeAssetComparablesStyle()

                  const assethover = response.results.filter((u) => !!u.graphic.attributes && !!u.graphic.attributes.id_portfolio)
                  if (assethover.length > 0) {
                    var graphicPf = assethover[0].graphic
                    vm.$root.$emit('comparableAssetHovered', graphicPf.attributes.id_portfolio)
                    vm.setAssetComparableStyle(graphicPf, true)
                  }
                }

                const flayer = response.results.filter((u) => u.graphic.layer !== null && u.graphic.layer.type === 'graphics')
                if (flayer.length > 0 && flayer[0].graphic.attributes !== undefined && flayer[0].graphic.attributes !== null) {
                  vm.currentFilterLayerHover = flayer[0].graphic.attributes
                } else {
                  vm.currentFilterLayerHover = null
                }
                // Reshape valuations
                if (response && response.results.length > 0 && response.results[0].graphic && response.results[0].graphic.geometry && response.results[0].graphic.geometry.type === 'point') {
                  if (response.results[0].graphic.attributes && response.results[0].graphic.attributes.tool) {
                    if (response.results[0].graphic.attributes.tool === 'reshape') {
                      document.getElementById('viewDiv').style.cursor = response.results[0].graphic.attributes.axis === 'y' ? 'row-resize' : 'col-resize'
                    } else if (response.results[0].graphic.attributes.tool === 'move') {
                      document.getElementById('viewDiv').style.cursor = 'pointer'
                    }
                  } else if (response.results[0].graphic.attributes && response.results[0].graphic.attributes.iD_comparable > 0) {
                    document.getElementById('viewDiv').style.cursor = 'pointer'
                  }
                }

                var results = response.results
                if (results.some(s => s.graphic.layer.title === 'newcongraphics') ||
                  results.some(s => s.graphic.layer.title === 'newsgraphics') ||
                  results.some(s => s.graphic.layer.title === 'transgraphics') ||
                  results.some(s => s.graphic.layer.title && s.graphic.layer.title.includes('GoalSeek'))) {
                  document.getElementById('viewDiv').style.cursor = 'pointer'
                } else {
                  document.getElementById('viewDiv').style.cursor = 'default'
                }
              })
            })
            setTimeout(() => {
              vm.$store.dispatch('maps/setmapview', vm.currentMapView)
            }, 1000)
          })
        })
    },
    drawcomparables() {
      const vm = this
      const color_pub_sel = [216, 175, 70, 1]
      const color_pub = [232, 210, 128, 1]
      const color_unpub_sel = [194, 194, 194, 1]
      const color_unpub = [240, 240, 240, 1]
      loadModules(
        [
          'esri/Color',
          'esri/geometry/Circle',
          'esri/geometry/Point',
          'esri/geometry/Polygon',
          'esri/Graphic',
          'esri/symbols/SimpleFillSymbol',
          'esri/symbols/SimpleLineSymbol',
          'esri/layers/FeatureLayer',
          'esri/layers/GraphicsLayer',
          'esri/symbols/SimpleMarkerSymbol'
        ], { css: true }
      ).then(([Color, Circle, Point, Polygon, Graphic, SimpleFillSymbol, SimpleLineSymbol, FeatureLayer, GraphicsLayer, SimpleMarkerSymbol]) => {
        const assets = vm.currentComparables
        if (vm.currentMap === null) return
        if (vm.centerGraphicval !== null || vm.centerGraphic !== null) {
          vm.currentMapView.graphics.remove(vm.centerGraphicval)
        }
        const centerPoint = new Point({
          longitude: vm.currentFilterValuations.c_longitud,
          latitude: vm.currentFilterValuations.c_latitud,
          spatialReference: {
            wkid: 4326
          }
        })
        var grapharr = []
        var sym = {
          type: 'simple-fill', // autocasts as new SimpleFillSymbol()
          color: [216, 175, 70, 0.2],
          outline: {
            // autocasts as new SimpleLineSymbol()
            color: [216, 175, 70, 0.9],
            width: '0.5px'
          }
        }

        if (vm.edgeNPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeNPointGraphic)
        }
        if (vm.edgeSPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeSPointGraphic)
        }
        if (vm.edgeWPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeWPointGraphic)
        }
        if (vm.edgeEPointGraphic) {
          vm.currentMapView.graphics.remove(vm.edgeEPointGraphic)
        }
        vm.edgeNPointGraphic = null
        vm.edgeSPointGraphic = null
        vm.edgeWPointGraphic = null
        vm.edgeEPointGraphic = null

        // radius
        if (vm.rings_search[0].length === 0) {
          vm.centerGraphicval = new Graphic(
            new Circle({
              center: centerPoint,
              radius: vm.currentFilterValuations.more_filters.search_radius,
              radiusUnit: 'meters',
              geodesic: true,
              attributes: { searchBy: 'circle', id: 'searchArea' }
            }),
            sym
          )
          vm.edgeNPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.currentFilterValuations.c_longitud,
              latitude: vm.centerGraphicval.geometry.extent.ymax
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape',
              axis: 'y'
            }
          })
          vm.edgeSPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.currentFilterValuations.c_longitud,
              latitude: vm.centerGraphicval.geometry.extent.ymin
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape',
              axis: 'y'
            }
          })
          vm.edgeWPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.centerGraphicval.geometry.extent.xmin,
              latitude: vm.currentFilterValuations.c_latitud
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape'
            }
          })
          vm.edgeEPointGraphic = new Graphic({
            geometry: new Point({
              longitude: vm.centerGraphicval.geometry.extent.xmax,
              latitude: vm.currentFilterValuations.c_latitud
            }),
            symbol: new SimpleMarkerSymbol({
              color: 'white',
              size: 7,
              outline: {
                color: [136, 150, 0],
                width: '1px'
              }
            }),
            attributes: {
              tool: 'reshape'
            }
          })
          // fin radius
        } else {
          vm.centerGraphicval = new Graphic(new Polygon({
            centroid: centerPoint,
            rings: vm.rings_search,
            geodesic: true,
            attributes: { searchBy: 'polygon' }
          }), sym)
        }

        grapharr.push(vm.centerGraphicval)
        if (vm.edgeNPointGraphic) {
          grapharr.push(vm.edgeNPointGraphic)
        }
        if (vm.edgeSPointGraphic) {
          grapharr.push(vm.edgeSPointGraphic)
        }
        if (vm.edgeWPointGraphic) {
          grapharr.push(vm.edgeWPointGraphic)
        }
        if (vm.edgeEPointGraphic) {
          grapharr.push(vm.edgeEPointGraphic)
        }

        // vm.currentMapView.graphics.add(vm.centerGraphicval)
        vm.currentMapView.graphics.addMany(grapharr)

        vm.currentMapView.zoom = vm.getZoomByRadius(vm.currentFilterValuations.more_filters.search_radius)

        var dataArray = []
        assets.forEach(element => {
          var colorSym = []
          var bIsSelected = false
          var bIsPublished = false
          if (element.c_categoria === 'Publicados' && vm.selectedcomparables.some(s => s.iD_comparable === element.iD_comparable)) {
            colorSym = color_pub_sel
            bIsSelected = true
            bIsPublished = true
          } else if (element.c_categoria === 'Publicados') {
            colorSym = color_pub
            bIsPublished = true
          } else if (vm.selectedcomparables.some(s => s.iD_comparable === element.iD_comparable)) {
            colorSym = color_unpub_sel
            bIsSelected = true
          } else {
            colorSym = color_unpub
          }

          var symbol = new SimpleMarkerSymbol({
            color: colorSym,
            size: '10px',
            angle: 180,
            style: 'circle',
            outline: new SimpleLineSymbol({
              color: [255, 255, 255],
              width: '1px'
            })
          })

          var pointGraphic = new Graphic({
            geometry: new Point({
              longitude: element.c_longitud,
              latitude: element.c_latitud
            }),
            symbol: symbol,
            attributes: {
              iD_comparable: element.iD_comparable,
              active: bIsSelected,
              pub: bIsPublished
            }
          })

          dataArray.push(pointGraphic)
        })
        vm.assetGraphicView.graphics = []
        vm.assetGraphicView.graphics.addMany(dataArray)
      })
    },
    getZoomByRadius(radius) {
      if (radius > 0 && radius <= 600) {
        return 16
      } else if (radius > 600 && radius <= 1500) {
        return 15
      } else if (radius > 1500 && radius <= 3200) {
        return 14
      } else if (radius > 3200 && radius <= 5900) {
        return 13
      } else if (radius > 5900 && radius <= 10000) {
        return 12
      } else {
        return 16
      }
    },
    exportMapAsPNG() {
      var vm = this
      vm.loading = true
      this.currentMapView.takeScreenshot().then((screenshot) => {
        const imgurlmap = screenshot.dataUrl
        var image = new Image()
        image.src = imgurlmap
        image.onload = function() {
          const link = document.createElement('a')
          link.href = imgurlmap
          link.download = 'BrainsMapExport.png'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
        setTimeout(() => {
          vm.loading = false
        }, 100)
      })
    }
  }
})
